import { createUseStyles } from "react-jss";
import { SPACING } from "../../../../constants/styleGuide";

const ViewInvoiceNotesStyles = createUseStyles({
    contentSpacing24: {
        paddingTop: SPACING.s24,
    },
    leftContent: {
        paddingRight: SPACING.s72,
    },
    infoIconSpacing: {
        marginLeft: SPACING.s8,
    },
    tag: {
        marginLeft: SPACING.s4,
        marginBottom: SPACING.s4,
        display: "inline-block",
    },
    descriptionText: {
        fontSize: "15px",
        paddingTop: '15px',
        whiteSpace: "break-spaces"
    },
    sideDivider: {
        paddingTop: SPACING.s24,
        '& > hr': {
            borderBottom: '0.0325rem solid #E3E4E5'
        }
    },
    pointerCursor: {
        cursor: "pointer",
    },
    publicSwitchLabel: {
        fontSize: "17px",
    },
    noteTitle: {
        paddingBottom: '20px'
    },
    contentSpacing16: {
        paddingTop: SPACING.s16,
    },
    icons: {
        textAlign: 'right',
        paddingBottom: '15px'
    },
    warningMsg: {
        padding: "20px 40px 0",
        background: "#fff",
    },
});

export default ViewInvoiceNotesStyles;